import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";
import React from "react";
import { Order } from "../../helpers/TableHelpers";
import { cn } from "@/lib/utils";

interface SortableTableColumnHeaderProps {
  label: string;
  sortProperty: string;
  getSort: () => string;
  setSort: (sort: string) => void;
  getOrder: () => Order;
  setOrder: (order: Order) => void;
}

const SortableTableColumnHeader: React.FC<SortableTableColumnHeaderProps> = ({ label, sortProperty, getSort, setSort, getOrder, setOrder }) => {
  const isActive = getSort() === sortProperty;
  const isAsc = getOrder() === "asc";

  const renderSortIcon = () => {
    if (!isActive) {
      return <ArrowUpDown className="size-4 text-muted-foreground" />;
    }
    if (isAsc) {
      return <ArrowUp className="size-4 text-primary" />;
    }
    return <ArrowDown className="size-4 text-primary" />;
  };

  return (
    <button
      type="button"
      onClick={() => {
        if (sortProperty === getSort()) {
          setOrder(getOrder() === "asc" ? "desc" : "asc");
        } else {
          setSort(sortProperty);
        }
      }}
      className={cn(
        "inline-flex cursor-pointer items-center gap-1 bg-transparent border-none p-0 font-semibold text-sm leading-none select-none",
        isActive ? "text-primary" : "text-foreground",
      )}
    >
      {label}
      <span className="inline-flex">
        {renderSortIcon()}
      </span>
    </button>
  );
};

export default SortableTableColumnHeader;
